import Nullstack from 'nullstack';
export default function IconRouterOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-router-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 13h2a2 2 0 0 1 2 2v2m-.588 3.417c-.362 .36 -.861 .583 -1.412 .583h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h8"
  }), "   ", Nullstack.element("path", {
    d: "M17 17v.01"
  }), "   ", Nullstack.element("path", {
    d: "M13 17v.01"
  }), "   ", Nullstack.element("path", {
    d: "M12.226 8.2a4 4 0 0 1 6.024 .55"
  }), "   ", Nullstack.element("path", {
    d: "M9.445 5.407a8 8 0 0 1 12.055 1.093"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}